import { render, staticRenderFns } from "./FilterCategoryModal.vue?vue&type=template&id=70ec49cd&"
import script from "./FilterCategoryModal.vue?vue&type=script&lang=js&"
export * from "./FilterCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports